import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8d7d5aba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8d7d5aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7d5aba",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/practice/answered/index.vue
// module id = null
// module chunks = 